import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Etiketler from '../pages/Etiketler';
import EtiketEkle from '../pages/Etiketler/create';
import MusteriTipleri from '../pages/MusteriTipleri';
import MusteriTipiEkle from '../pages/MusteriTipleri/create';
import Formlar from '../pages/Formlar';
import Reklamlar from '../pages/Reklamlar';
import Profil from '../pages/Profil';
import SifreDegistir from '../pages/SifreDegistir';
import FormDetay from '../pages/FormDetay';
import Logout from '../pages/Logout';
import ProtectedRoute from '../components/ProtectedRoute';
import Reports from '../pages/Reports';
import CustomerCreate from '../pages/Customer/create';
import Temsilciler from '../pages/Temsilciler';
import AcenteYonetimi from '../pages/AcenteYonetimi';
import AcenteEkle from '../pages/AcenteYonetimi/create';
import AcenteDetay from '../pages/AcenteYonetimi/detay';
import AcenteRaporOlustur from '../pages/AcenteRaporOlustur';

const AppRoutes = () => (
    <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/dashboard" element={<ProtectedRoute allowedRules={[0]}><Dashboard /></ProtectedRoute>} />
        <Route path="/labels" element={<ProtectedRoute allowedRules={[0]}><Etiketler /></ProtectedRoute>} />
        <Route path="/create-label" element={<ProtectedRoute allowedRules={[0]}><EtiketEkle /></ProtectedRoute>} />
        <Route path="/customer-types" element={<ProtectedRoute allowedRules={[0]}><MusteriTipleri /></ProtectedRoute>} />
        <Route path="/create-customer-type" element={<ProtectedRoute allowedRules={[0]}><MusteriTipiEkle /></ProtectedRoute>} />
        <Route path="/forms" element={<ProtectedRoute allowedRules={[0, 1]}><Formlar /></ProtectedRoute>} />
        <Route path="/agents" element={<ProtectedRoute allowedRules={[0]}><Temsilciler /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute allowedRules={[0]}><Reports /></ProtectedRoute>} />
        <Route path="/create-customer" element={<ProtectedRoute allowedRules={[0, 1]}><CustomerCreate /></ProtectedRoute>} />
        <Route path="/agencies" element={<ProtectedRoute allowedRules={[0, 1]}><AcenteYonetimi /></ProtectedRoute>} />
        <Route path="/create-agency" element={<ProtectedRoute allowedRules={[0, 1]}><AcenteEkle /></ProtectedRoute>} />
        <Route path="/agency-detail" element={<ProtectedRoute allowedRules={[0, 1]}><AcenteDetay /></ProtectedRoute>} />
        <Route path="/agency-reports" element={<ProtectedRoute allowedRules={[0]}><AcenteRaporOlustur /></ProtectedRoute>} />
        <Route path="/lead-detail" element={<ProtectedRoute allowedRules={[0, 1]}><FormDetay /></ProtectedRoute>} />
        <Route path="/ads" element={<ProtectedRoute allowedRules={[0]}><Reklamlar /></ProtectedRoute>} />
        <Route path="/my-account" element={<ProtectedRoute allowedRules={[0, 1]}><Profil /></ProtectedRoute>} />
        <Route path="/change-password" element={<ProtectedRoute allowedRules={[0, 1]}><SifreDegistir /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
);

export default AppRoutes;
